import React from 'react';
import { IBrand } from '../types';

const brandsColumns = [
  {
    Header: 'Vendor',
    accessor: 'name',
  },
  {
    Header: 'No of outlets',
    accessor: 'outletCount',
  },
  {
    Header: 'Orders',
    accessor: 'orderCount',
  },
  {
    Header: 'Date created',
    accessor: 'createdAt',
  },
  {
    Header: 'Date updated',
    accessor: 'updatedAt',
  },
  {
    Header: 'Status',
    accessor: 'statusDisplay',
  },
  {
    Header: 'Actions',
    accessor: 'id',
  },
];

const brandMealColumns = [
  {
    Header: 'Meal',
    accessor: 'name',
  },
  {
    Header: 'Price',
    accessor: 'basePrice',
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Action',
  },
];

const groupColumns = [
  {
    Header: 'Group Name',
    accessor: 'title',
  },
  {
    Header: 'Date Created',
    accessor: 'createdAt',
  },
  {
    Header: 'Action',
  },
];

const groupStatus = [
  { label: 'Active', value: 1 },
  { label: 'Inactive', value: 0 },
];

const brandStatus = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Opened', value: 'OPENED' },
  { label: 'Closed', value: 'CLOSED' },
];

export const brandServices = [
  { value: 'BULK', label: 'Bulk' },
  { value: 'DELIVERY', label: 'Delivery' },
  { value: 'PICKUP', label: 'Pickup' },
  { value: 'SCHEDULED', label: 'Scheduled' },
  { value: 'GROUPS', label: 'Groups' },
  { value: 'EVENTS', label: 'Events' },
] as const;
export const getStatusColor = (status: string) => {
  return status === 'Active' || status === 'Available'
    ? 'bg-green-500'
    : 'bg-gray-400';
};

// Transform data for the Table component
const transformedBrands = (brands: IBrand[]) => {
  return brands.map((brand) => ({
    ...brand,
    outletCount: (brand as any).kitchens?.length ?? 0,
    orderCount: (brand as any).orderCount ?? '--',
    statusDisplay:
      brand.status === 'ACTIVE' || brand.status === 'OPENED'
        ? 'Active'
        : 'Inactive',
  }));
};

const outletVendorColumns = [
  {
    Header: 'OUTLET NAME',
    accessor: 'outletName',
  },
  {
    Header: 'OUTLET OWNER',
    accessor: 'outletOwner',
  },
  {
    Header: 'OUTLET LOCATION',
    accessor: 'outletLocation',
  },
  {
    Header: 'NO. OF USERS',
    accessor: 'noOfUsers',
  },
  {
    Header: 'DELIVERY RADIUS(KM)',
    accessor: 'deliveryRadius',
  },
  {
    Header: 'STATUS',
    accessor: 'status',
    Cell: ({ row }: any) => (
      <div className="flex items-center">
        <div
          className={`h-2 w-2 rounded-full mr-2 ${row.original.statusColor}`}
        ></div>
        <span className="text-sm text-gray-900">{row.original.status}</span>
      </div>
    ),
  },
  {
    Header: 'DATE CREATED',
    accessor: 'createdAt',
  },
];

const ProductColumns = [
  {
    Header: 'S/N',
    accessor: 'sn',
    Cell: ({ row }: any) => (
      <div className="flex items-center relative">
        <span className="mr-2">{row.original.sn}</span>
        <span
          className={`px-2 py-1 absolute bottom-4 left-3 rounded-full text-xs font-medium ${row.original.stockLevelColor}`}
        >
          {row.original.stockLevelLabel}
        </span>
      </div>
    ),
  },
  {
    Header: 'VARIANT',
    accessor: 'variant',
  },
  {
    Header: 'SKU',
    accessor: 'sku',
  },
  {
    Header: 'STOCK',
    accessor: 'stock',
  },
  {
    Header: 'STATUS',
    accessor: 'status',
    Cell: ({ row }: any) => (
      <div className="flex items-center">
        <div
          className={`h-2 w-2 rounded-full mr-2 ${row.original.statusColor}`}
        ></div>
        <span className="text-sm text-gray-900">{row.original.status}</span>
      </div>
    ),
  },
  {
    Header: 'MIN QTY',
    accessor: 'minQty',
  },
];

const BrandInventoryColumns = [
  {
    Header: 'S/N',
    accessor: 'serialNumber',
  },
  {
    Header: 'VENDOR',
    accessor: 'vendorName',
  },
  {
    Header: 'IN STOCK',
    accessor: 'inStock',
  },
  {
    Header: 'STATUS',
    accessor: 'status',
    Cell: ({ row }: any) => (
      <div className="flex items-center">
        <div
          className={`h-2 w-2 rounded-full mr-2 ${row.original.statusColor}`}
        ></div>
        <span className="text-sm text-gray-900">{row.original.status}</span>
      </div>
    ),
  },
  {
    Header: 'LAST UPDATED',
    accessor: 'lastUpdated',
  },
];

export {
  brandsColumns,
  brandMealColumns,
  groupColumns,
  groupStatus,
  brandStatus,
  transformedBrands,
  outletVendorColumns,
  ProductColumns,
  BrandInventoryColumns,
};
